/**
 * EDIT FEED ENTRY POINT
 *
 * This page allows the user to edit feed data, in a similar fashion to the Add RSS Feed page.
 *
 * @version 0.1
 */

import actions from './EditFeed.actions';

import BaseFeedEditingComponent from './../BaseFeedEditingComponent/BaseFeedEditingComponent.index.jsx';

export default class EditFeed extends BaseFeedEditingComponent {

    componentWillMount() {
        super.componentWillMount('editFeed', this.props.params.feedId);

        actions.loadFeedInfo(this.props.params.feedId);
    }

    render() {
        return super.render(this.props.params.feedId);
    }

}


// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/EditFeed/EditFeed.index.jsx